import React, { useState } from "react";
import EmailApi from "../../api/EmailApi";
import { showSuccess, showError } from "../../utils/toastUtils";

const AddDetails = ({ onSuccess }) => {
  const [form, setForm] = useState({
    to: "",
    subject: "",
    message: "",
  });

  const [attachment, setAttachment] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleConfirmOpen = () => {
    if (!form.to || !form.subject || !form.message) {
      return showError("All fields are required");
    }

    const modalEl = document.getElementById("send-email-confirm-modal");
    const modal = new window.bootstrap.Modal(modalEl);
    modal.show();
  };

  const handleSend = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("to", form.to);
      formData.append("subject", form.subject);
      formData.append("message", form.message);
      if (attachment) formData.append("attachment", attachment);

      const res = await EmailApi.send(formData);

      if (res.code === 200) {
        showSuccess("Email sent successfully");

        setForm({ to: "", subject: "", message: "" });
        setAttachment(null);

        const modalEl = document.getElementById("send-email-confirm-modal");
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        modal?.hide();

        onSuccess?.();
      } else {
        showError(res.message);
      }
    } catch {
      showError("Failed to send email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ================= EMAIL FORM ================= */}
      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">Send Email</h5>
        </div>

        <div className="card-body">
          <div className="mb-3">
            <label className="form-label">To</label>
            <input
              type="email"
              name="to"
              className="form-control"
              value={form.to}
              onChange={handleChange}
              placeholder="example@email.com"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Subject</label>
            <input
              name="subject"
              className="form-control"
              value={form.subject}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Message</label>
            <textarea
              name="message"
              rows={5}
              className="form-control"
              value={form.message}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Attachment (optional)</label>
            <input
              type="file"
              className="form-control"
              onChange={(e) => setAttachment(e.target.files[0])}
            />
          </div>

          <div className="text-end">
            <button
              className="btn btn-primary"
              onClick={handleConfirmOpen}
              disabled={loading}
            >
              Send Email
            </button>
          </div>
        </div>
      </div>

      {/* ================= CONFIRM MODAL (DELETE STYLE) ================= */}
      <div
        className="modal fade"
        id="send-email-confirm-modal"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body p-4 text-center">
              <div className="mb-3">
                <span className="avatar avatar-xl bg-primary text-white rounded-circle">
                  <i className="ti ti-mail fs-24" />
                </span>
              </div>

              <h5 className="mb-1">Send Email</h5>
              <p className="mb-3">
                Are you sure you want to send this email?
              </p>

              <div className="d-flex gap-2">
                <button
                  className="btn btn-light w-100"
                  data-bs-dismiss="modal"
                  disabled={loading}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-primary w-100"
                  onClick={handleSend}
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Yes, Send"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDetails;
